import { getDomain } from "./common";

const insideIframe = window.self !== window.top;
const allowLocalhost = parseBool(import.meta.env.VITE_ALLOW_LOCALHOST);
var hostOrigin = import.meta.env.DRFUHRMAN_SHOP;
var hostIsConfirmed = false;
var unsentMessages = [];

function getOriginDomain(origin) {
    var url = new URL(origin);
    // We used to use getDomain from tldts here, with the following options:
    // {
    //     extractHostname: false,
    //     detectIp: false,
    //     validHosts: [ 'localhost' ],
    // }
    // Due to the size of tldts, we use a narrow replacement out of common.js now.
    return getDomain(url.hostname);
}

function setConfirmedHostOrigin(origin) {
    if (!insideIframe) return;
    if (hostIsConfirmed || !origin) return;

    // Only allow origins with the same top-level domain.
    // Lock in the assumed origin if the passed one is not allowed.
    if (getOriginDomain(origin) == getOriginDomain(window.origin)) {
        hostOrigin = origin;
    } else if (allowLocalhost && getOriginDomain(origin) == 'localhost') {
        hostOrigin = origin;
    }

    hostIsConfirmed = true;
    unsentMessages.forEach(sendMessage);
    unsentMessages = null;
}

function getConfirmedHostOrigin() {
    if (hostIsConfirmed) {
        return hostOrigin;
    }
}

function sendMessage(msg) {
    if (!insideIframe) return;

    if (msg.DRF) {
        msg = msg.DRF;
    }

    if (!hostIsConfirmed) {
        // Discard earlier login-required, update-data, update-dirty, and request-resize messages, and only finally send the last attempted one.
        // For show-dialog and report-error, all messages need to be saved.
        if (msg.subject != 'show-dialog' && msg.subject != 'report-error') {
            unsentMessages = unsentMessages.filter(m => m.subject != msg.subject);
        }

        unsentMessages.push(structuredClone(msg));
    } else {
        window.parent.postMessage({
            DRF: msg,
        }, hostOrigin);
    }
}

function parseBool(str) {
    // Covers all falsy values, including empty string
    if (!str) return false;

    // Make sure it's a string now, and trim.
    str = String(str).trim();

    // Covers number zero and empty string
    if (str == false) return false;

    // Covers the word false
    if (str.toLowerCase() == 'false') return false;

    // Everything else converts to true.
    return true;
}

export {
    insideIframe,
    setConfirmedHostOrigin,
    getConfirmedHostOrigin,
    sendMessage,
};